import React from "react"

interface PaginationProps {
  page: number
  totalPages: number
  totalCount: number
  hasNextPage: boolean
  onPrev: () => void
  onNext: () => void
}

const Pagination: React.FC<PaginationProps> = ({
  page,
  totalPages,
  totalCount,
  hasNextPage,
  onPrev,
  onNext,
}) => {
  if (totalPages <= 1) return null

  return (
    <div className="flex items-center gap-4 mt-4 text-sm">
      <button
        onClick={onPrev}
        disabled={page === 1}
        className="font-bold uppercase text-xs disabled:opacity-30 hover:underline"
      >
        ← Prev
      </button>
      <span className="text-gray-600 text-xs">
        Page {page} of {totalPages} ({totalCount} total)
      </span>
      <button
        onClick={onNext}
        disabled={!hasNextPage}
        className="font-bold uppercase text-xs disabled:opacity-30 hover:underline"
      >
        Next →
      </button>
    </div>
  )
}

export default Pagination
